import { render, staticRenderFns } from "./FAQS_1st_col.vue?vue&type=template&id=ce36d2b6&scoped=true"
import script from "./FAQS_1st_col.vue?vue&type=script&lang=js"
export * from "./FAQS_1st_col.vue?vue&type=script&lang=js"
import style0 from "./FAQS_1st_col.vue?vue&type=style&index=0&id=ce36d2b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce36d2b6",
  null
  
)

export default component.exports